import actionContext from '../contexts/actions';
import { useContext } from 'react';

export default useAPI;

/**
 *
 * @return {InternalAPI}
 */
function useAPI() {
  return useContext(actionContext);
}
